
// import numeral from '??'
// import moment from '??'

export default {
  
  data(){
    return {
      // Place default formatters in here
      _f:{
        day: "ddd MMMM Do YYYY, h:mm a",
      }
    }
  },

  methods:{
    D: function(val, formatter="ddd MMMM Do YYYY, h:mm a", invalidDateText=""){
      const result = moment.utc(val).format(formatter);
      return result === "Invalid date" ? invalidDateText : result;
    },
  
    F: function(val, formatter='0,000.00'){
      return numeral(val).format(formatter);
    },
    capitalize(str){
      // taken from https://stackoverflow.com/questions/32589197/how-can-i-capitalize-the-first-letter-of-each-word-in-a-string-using-javascript
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
      }
      return splitStr.join(' '); 
    },
  },

  filters:{
    DF: function(val, formatter="ddd MMMM Do YYYY, h:mm a", invalidDateText=""){
        const result = moment.utc(val).format(formatter);
        return result === "Invalid date" ? invalidDateText : result;
    },
  
    NF: function(val, formatter='0,000.00'){
      return numeral(val).format(formatter);
    },
  },
  

}